import { createContext, useCallback, useRef, useState } from 'react';
const utf8 = require('utf8');

const fetch = require('../utils/fetch');

const GeneralContext = createContext();

export const GeneralProvider = ({children}) => {

    const redirect = async (expectedRole) => {
        const response = await fetch.fetchGet('verify-role');
        if (!response.success) {
            return { success: false };
        } else if (response.role !== expectedRole) {
            if (response.role === 'super_admin') {return { success: true, points: response.points }}
            if (response.role === 'admin' && expectedRole === 'user') {return { success: true, points: response.points }}
            return { success: false };
        } else {
            setUserName(utf8.decode(JSON.parse(atob(localStorage.getItem('token').split('.')[1])).first_name));
            return { success: true, points: response.points };
        }
    }

    const growingWidth = useRef('100vw');
    const firstResize = useRef(false);
    const animationDuration = useRef(1);
    const animationDelay = useRef(1.5);

    const resizeIndex = useCallback(() => {
        if (firstResize) {
            animationDuration.current = 0;
            animationDelay.current = 0;
        }
        firstResize.current = true;
        if (document.getElementById('rightSplashScreen')) {
            window.innerWidth < 800 ? growingWidth.current ='100vw' : growingWidth.current = '50vw';
            document.getElementById('rightSplashScreen').style.maxWidth = growingWidth.current;
            document.getElementById('rightSplashScreen').style.width = growingWidth.current;
        }
    }, []);

    const resizeOnload = () => {
        animationDuration.current = 1;
        animationDelay.current = 1.5;
        window.innerWidth < 800 ? growingWidth.current ='100vw' : growingWidth.current = '50vw';
    }

    const [firstLoad, setFirstLoad] = useState(true);
    const changeFirstLoad = () => {
        setFirstLoad(false);
    }

    const [activeMode, setActiveMode] = useState('login');
    const changeActiveMode = (mode) => {
        setActiveMode(mode);
    }

    const logout = () => {
        localStorage.clear();
    }

    const [userName, setUserName] = useState('');

    const [userPoints, setUserPoints] = useState(0);
    const changeUserPoints = (points) => {
        setUserPoints(points);
    }

    const [benefitList, setBenefitList] = useState([]);
    const changeBenefitList = (list) => {
        setBenefitList(list);
    }
    const [chosenBenefit, setChosenBenefit] = useState({id: 0, text: '', value: ''});
    const findInBenefitList = (e) => {
        const title = e.target.value;
        let found = false;
        for (let i = 0; i < benefitList.length; i++) {
            if (title === benefitList[i].title) {
                found = true;
                setChosenBenefit(benefitList[i]);
            }
        }
        if (!found) {
            setChosenBenefit({id: 0, text: '', value: ''});
        }
    }

    function closeMobileModal () {
        const modal = document.getElementById("mobileModal");
        modal.style.animation = 'disappear 0.5s';
        modal.addEventListener("animationend", function finAnimacion () {
            modal.removeEventListener("animationend", finAnimacion);
            modal.style.display = "none";
            modal.style.animation = 'appear 0.5s';
        })
    }

    const [currentMenu, setCurrentMenu] = useState('user');
    const changeCurrentMenu = (mode) => {
        setCurrentMenu(mode);
        if (document.getElementById("mobileModal").style.display === 'block') {closeMobileModal();}
    }

    const [userMenu, setUserMenu] = useState('user');
    const changeUserMenu = (mode) => {
        setUserMenu(mode);
        if (document.getElementById("mobileModal").style.display === 'block') {closeMobileModal();}
    }

    const [modalTitle, setModalTitle] = useState('Título');
    const changeModalTitle = (title) => {
        setModalTitle(title);
    }

    const [modalText, setModalText] = useState('Ejemplo de contenido');
    const changeModalText = (text) => {
        setModalText(text);
    }

    const [modalContent, setModalContent] = useState([{id: 0, text: 'Ejemplo línea 1'}]);
    const changeModalContent = (content) => {
        setModalContent(content);
    }

    const [modalType, setModalType] = useState('alert');
    const changeModalType = (type) => {
        setModalType(type)
    }

    const [modalClass, setModalClass] = useState('button');
    const changeModalClass = (newClass) => {
        setModalClass(newClass);
    }

    const [modalFunction1, setModalFunction1] = useState(() => () => {console.log('Función por defecto');});
    const changeModalFunction1 = (newFunction) => {
        setModalFunction1(newFunction);
    }

    const [modalFunction2, setModalFunction2] = useState(() => () => {console.log('Función por defecto');});
    const changeModalFunction2 = (newFunction) => {
        setModalFunction2(newFunction);
    }

    const [benefitEditId, setBenefitEditId] = useState('');
    const [benefitEditTitle, setBenefitEditTitle] = useState('');
    const [benefitEditValue, setBenefitEditValue] = useState('');
    const [userHistoryId, setUserHistoryId] = useState('');
    const [userAdminHistoryId, setUserAdminHistoryId] = useState('');
    const [userAdminHistoryName, setUserAdminHistoryName] = useState('');
    const [activePasswordDocument, setActivePasswordDocument] = useState('');
    const [activePasswordQuestion, setActivePasswordQuestion] = useState('');
    const [activePasswordId, setActivePasswordId] = useState('');
    const [delayTimer, setDelayTimer] = useState(3);
    const [userResetData, setUserResetData] = useState({});
    const [userType, setUserType] = useState('');

    return <GeneralContext.Provider value={{
        redirect,
        resizeIndex,
        resizeOnload,
        growingWidth,
        animationDuration,
        animationDelay,
        firstLoad,
        changeFirstLoad,
        activeMode,
        changeActiveMode,
        logout,
        userName,
        userPoints,
        changeUserPoints,
        userMenu,
        changeUserMenu,
        currentMenu,
        changeCurrentMenu,
        benefitList,
        changeBenefitList,
        chosenBenefit,
        findInBenefitList,
        modalTitle,
        changeModalTitle,
        modalText,
        changeModalText,
        modalContent,
        changeModalContent,
        modalType,
        changeModalType,
        modalClass,
        changeModalClass,
        modalFunction1,
        changeModalFunction1,
        modalFunction2,
        changeModalFunction2,
        benefitEditId,
        setBenefitEditId,
        benefitEditTitle,
        setBenefitEditTitle,
        benefitEditValue,
        setBenefitEditValue,
        userHistoryId,
        setUserHistoryId,
        userAdminHistoryId,
        setUserAdminHistoryId,
        userAdminHistoryName,
        setUserAdminHistoryName,
        activePasswordDocument,
        setActivePasswordDocument,
        activePasswordQuestion,
        setActivePasswordQuestion,
        activePasswordId,
        setActivePasswordId,
        delayTimer,
        setDelayTimer,
        userResetData,
        setUserResetData,
        userType,
        setUserType
    }}>
        {children}
    </GeneralContext.Provider>
}

export default GeneralContext;